module.exports = "/assets/fonts/2dda86ad.svg";